import { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

/**
 * Lazily loads the Stripe.js instance. Returns a stable promise
 * that resolves to the Stripe object (or null if key is not configured).
 *
 * Usage:
 *   const { stripePromise } = useStripeSetup();
 *   <Elements stripe={stripePromise} options={{ clientSecret }}>
 */
export function useStripeSetup() {
  const stripePromise = useMemo(() => {
    if (!stripePublishableKey) {
      if (import.meta.env.DEV)
        console.warn('VITE_STRIPE_PUBLISHABLE_KEY is not set — Stripe will not load');
      return Promise.resolve(null);
    }
    return loadStripe(stripePublishableKey);
  }, []);

  return { stripePromise };
}
